/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TipoEmpleoEstadoIdJobTypePatch$Params {
  Accept?: string;
  idJobType: string;
      body?: {
}
}

export function tipoEmpleoEstadoIdJobTypePatch(http: HttpClient, rootUrl: string, params: TipoEmpleoEstadoIdJobTypePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, tipoEmpleoEstadoIdJobTypePatch.PATH, 'patch');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.path('idJobType', params.idJobType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

tipoEmpleoEstadoIdJobTypePatch.PATH = '/tipo-empleo/estado/{idJobType}';
